<fgb-banner [pageTitle]="'worksheet.page.title'"></fgb-banner>
<fgb-page-header [pageTitle]="'worksheet.page.title'" [backButtonLink]="'/'" [showBalance]="false" />

<div class="mt-lg-3 text-center">
  <fgb-worksheet-list pageRequested="Newsletters"></fgb-worksheet-list>
</div>
